module.exports = __webpack_public_path__ + "static/media/chipper2x.aeace704.png";